module.exports = new __parcel__URL__("hud_rewards_button.29fc15c1.png").toString();